import { type AlignContent, type ContentPosition, type Rect } from "@common/hocs/withDropdown/lib";

export const alignContent: AlignContent = (toggleRect: Rect, contentRect: Rect): ContentPosition => ({
  align: "custom",
  left: toggleRect.left - contentRect.width + 30,
  top: toggleRect.bottom - 30
});
